import type {
  ExpenseStatus,
  ExpenseFundingSource,
  ExpenseValidation,
  SalePaymentMethod,
} from "@artisancode/api-types";

export { EXPENSE_CATEGORY_LABELS } from "@artisancode/api-types";

export const EXPENSE_PAYMENT_METHOD_LABELS: Record<SalePaymentMethod, string> =
  {
    cash: "Tunai",
    edc: "EDC",
    qris: "QRIS",
    app_qris: "App QRIS",
    bank_transfer: "Transfer",
    credit_unpaid: "Kasbon/Belum Bayar",
  };

export const EXPENSE_FUNDING_SOURCE_LABELS: Record<
  ExpenseFundingSource,
  string
> = {
  cash: "Cash",
  qris: "Qris",
  bank_mandiri: "Mandiri",
  loan: "Pinjaman",
};

export const EXPENSE_VALIDATION_LABELS: Record<ExpenseValidation, string> = {
  ok: "OK",
  check_amount: "Cek Jumlah",
  unpaid: "Belum Dibayar",
  proof_missing: "Bukti Belum Ada",
};

export const EXPENSE_STATUS_LABELS: Record<ExpenseStatus, string> = {
  draft: "Draft",
  done: "Selesai",
};
